import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import HeaderPortal from 'components/layout/HeaderPortal';
import ListBrowserComponent from './ListBrowserComponent';
import { withAreaGetter } from 'providers/AreasConsumers';
import { areas } from 'constants/areas';
import Portal from 'utils/portal/Portal';
import { useTranslation } from 'react-i18next';
import { IconButton } from '@totalsoft/rocket-ui';
import { defaultMethod, methodModalVar } from '../variables';
import PermissionCheck from 'components/common/PermissionCheck';
import { ADMIN_COMMISSION_CALCULATION_METHOD_WRITE, ADMIN_COMMISSION_CALCULATION_METHOD_READ } from 'constants/rightsCodes';

const Route = ({ getElemByAreaKey }) => {
  const { t } = useTranslation();
  return (
    <Fragment>
      <HeaderPortal />
      <Portal container={getElemByAreaKey(areas.headerLinks)}>
        <PermissionCheck authorizationCode={ADMIN_COMMISSION_CALCULATION_METHOD_WRITE} withForbiddenPage={false}>
          <IconButton
            type='add'
            fontSize='medium'
            color='transparent'
            tooltip={t('Add')}
            onClick={() => methodModalVar({ open: true, method: defaultMethod })}
          />
        </PermissionCheck>
      </Portal>
      <PermissionCheck authorizationCode={ADMIN_COMMISSION_CALCULATION_METHOD_READ}>
        <ListBrowserComponent />
      </PermissionCheck>
    </Fragment>
  );
};

Route.propTypes = {
  getElemByAreaKey: PropTypes.func
};

export default withAreaGetter(Route);
